module.exports = __webpack_public_path__ + "static/img/12-7new1.52640c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/english/12-7new1.png
// module id = yZMJ
// module chunks = 15